import React from 'react';
import { Tooltip } from 'antd';
import { RadioButtonText } from "./styles";
import { RadioButton } from '../../../../../../CommonComponents/commonStyles';

const RadioTitle = ({ text, unit, toolTipText, exchangeType, activeExchangeUnit, onClick, checked, disabled }) => {
    return (
        <>
            <div style={{ marginBottom: "0px" }}>
                <Tooltip radioTooltipWidth="170px" title={toolTipText} placement="bottomLeft">
                    <RadioButton
                        value={unit}
                        onClick={(e) => onClick(e.target.value)}
                        checked={checked}
                        disabled={disabled}
                        aria-label={text}
                    />
                </Tooltip>
            </div>
            <RadioButtonText>{text}</RadioButtonText>
        </>
    );
};

export default RadioTitle;